import React from 'react';

// Import các icon từ lucide-react
import { User, Phone, Mail, MapPin, Camera, FileText, ShoppingBag, CreditCard, Facebook } from 'lucide-react';

// Main App component
const App = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 font-sans text-gray-800 p-4 sm:p-6 lg:p-8">
      {/* Container chính của trang */}
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden">
        {/* Header của trang chính sách */}
        <header
          className="p-6 sm:p-8 text-center rounded-t-3xl text-white"
          style={{
            backgroundImage: 'linear-gradient(to right, #6094EA 0%, #AA4FF4 39%, #FF00FF 70%, #FF35A3 94%)'
          }}
        >
          <h1 className="text-3xl sm:text-4xl font-extrabold mb-2 leading-tight">
            Chính Sách Thu Thập & Sử Dụng Dữ Liệu
          </h1>
          <p className="text-lg opacity-90">
            Minh bạch vì mục đích học tập và nghiên cứu
          </p>
        </header>

        {/* Nội dung chính sách */}
        <main className="p-6 sm:p-8 lg:p-10 space-y-8">
          {/* Mục đích thu thập dữ liệu */}
          <section className="bg-blue-50 p-6 rounded-2xl shadow-inner border-l-4 border-blue-500">
            <h2 className="text-2xl font-bold text-blue-800 mb-4 flex items-center">
              <FileText className="mr-3 text-blue-600" size={28} />
              Mục Đích Thu Thập Dữ Liệu
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Chúng tôi thu thập các thông tin cá nhân của người dùng (bao gồm tên, số điện thoại, email, địa chỉ và ảnh) với mục đích duy nhất là phục vụ cho các dự án học tập và nghiên cứu. Dữ liệu này giúp chúng tôi phát triển, thử nghiệm và cải thiện các tính năng của ứng dụng trong môi trường mô phỏng.
            </p>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex items-center text-gray-700">
                <User className="mr-2 text-blue-500" size={20} /> Tên
              </div>
              <div className="flex items-center text-gray-700">
                <Phone className="mr-2 text-blue-500" size={20} /> Số điện thoại
              </div>
              <div className="flex items-center text-gray-700">
                <Mail className="mr-2 text-blue-500" size={20} /> Email
              </div>
              <div className="flex items-center text-gray-700">
                <MapPin className="mr-2 text-blue-500" size={20} /> Địa chỉ
              </div>
              <div className="flex items-center text-gray-700">
                <Camera className="mr-2 text-blue-500" size={20} /> Ảnh
              </div>
            </div>
          </section>

          {/* Chính sách về đơn hàng */}
          <section className="bg-purple-50 p-6 rounded-2xl shadow-inner border-l-4 border-purple-500">
            <h2 className="text-2xl font-bold text-purple-800 mb-4 flex items-center">
              <ShoppingBag className="mr-3 text-purple-600" size={28} />
              Chính Sách Đơn Hàng & Giao Nhận
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Các đơn hàng được tạo và mua thông qua ứng dụng của chúng tôi chỉ nhằm mục đích thử nghiệm và học tập. Do đó, việc giao hàng tận nhà có thể hoặc không được thực hiện. Đây không phải là một dịch vụ thương mại thực tế và không có cam kết về việc hoàn tất giao dịch vật lý.
            </p>
            <ul className="list-disc list-inside mt-4 text-gray-700 space-y-2">
              <li>Đơn hàng chỉ để thử nghiệm tính năng.</li>
              <li>Không đảm bảo giao hàng tận nhà.</li>
              <li>Không phát sinh nghĩa vụ thương mại.</li>
            </ul>
          </section>

          {/* Chính sách thanh toán */}
          <section className="bg-green-50 p-6 rounded-2xl shadow-inner border-l-4 border-green-500">
            <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
              <CreditCard className="mr-3 text-green-600" size={28} />
              Chính Sách Thanh Toán (MoMo UAT)
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Tất cả các giao dịch thanh toán trong ứng dụng được thực hiện thông qua cổng thanh toán MoMo UAT (User Acceptance Testing) và chỉ phục vụ cho giai đoạn thử nghiệm.
            </p>
            <p className="text-gray-700 leading-relaxed mt-2 font-semibold">
              <span className="text-red-600 font-bold">Lưu ý quan trọng:</span> Các giao dịch này KHÔNG phát sinh bất kỳ giao dịch thực tế nào được lưu trữ trong hệ thống MoMo chính thức và KHÔNG liên quan đến tài khoản MoMo thực của bạn.
            </p>
            <ul className="list-disc list-inside mt-4 text-gray-700 space-y-2">
              <li>Chỉ dùng cho mục đích thử nghiệm.</li>
              <li>Không có giao dịch tiền thật.</li>
              <li>Không ảnh hưởng đến tài khoản MoMo thực.</li>
            </ul>
          </section>

          {/* Liên hệ */}
          <section className="bg-yellow-50 p-6 rounded-2xl shadow-inner border-l-4 border-yellow-500">
            <h2 className="text-2xl font-bold text-yellow-800 mb-4 flex items-center">
              <Facebook className="mr-3 text-yellow-600" size={28} />
              Liên Hệ & Giải Đáp Thắc Mắc
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nếu bạn có bất kỳ câu hỏi hoặc cần làm rõ thêm về chính sách thu thập và sử dụng dữ liệu của chúng tôi, vui lòng liên hệ qua trang Facebook chính thức:
            </p>
            <div className="text-center">
              <a
                href="https://www.facebook.com/PCPB.page?locale=vi_VN"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-full shadow-lg hover:bg-blue-700 transform hover:scale-105 transition-all duration-300 ease-in-out"
              >
                <Facebook className="mr-3" size={24} />
                Truy Cập Trang Facebook Của Chúng Tôi
              </a>
            </div>
          </section>
        </main>

        {/* Footer của trang */}
        <footer className="bg-gray-800 text-white p-6 sm:p-8 text-center rounded-b-3xl mt-8">
          <p className="text-sm opacity-80">
            &copy; {new Date().getFullYear()} PCPB.
          </p>
          <p className="text-xs opacity-70 mt-2">
            Đây là một trang web chính sách thử nghiệm và không phải là một dịch vụ thương mại.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default App; 